/* eslint-disable no-param-reassign */
import {
  setToken, setRefreshToken, removeToken, removeRefreshToken,
} from '@/util/auth'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Vue from '@/main'
import { setStore, getStore } from '@/util/store'
import { isURL, validatenull } from '@/util/validate'
import { deepClone } from '@/util/util'
import { getList as getDictlist, getBizList as getDictBizlist } from '@/api/system/dict'
import website from '@/config/website'
import {
  loginByUsername, loginByToken, loginBySocial, logout, refreshToken, getButtons, getUserAllInfo,
} from '@/api/user'
import { getTopMenu, getRoutes } from '@/api/system/menu'
import md5 from 'js-md5'
import templateFormAPI from '@/api/templateForm/index'

function addPath(ele, first) {
  const { menu } = website
  const propsConfig = menu.props
  const propsDefault = {
    label: propsConfig.label || 'name',
    path: propsConfig.path || 'path',
    icon: propsConfig.icon || 'icon',
    children: propsConfig.children || 'children',
  }
  const icon = ele[propsDefault.icon]
  ele[propsDefault.icon] = validatenull(icon) ? menu.iconDefault : icon
  const isChild = ele[propsDefault.children] && ele[propsDefault.children].length !== 0
  if (!isChild) ele[propsDefault.children] = []
  if (!isChild && first && !isURL(ele[propsDefault.path])) {
    ele[propsDefault.path] = `${ele[propsDefault.path]}/index`
  } else {
    ele[propsDefault.children].forEach(child => {
      addPath(child)
    })
  }
}
function isOverTime(updatePasswordTime) {
  // eslint-disable-next-line no-shadow
  let isOverTime = false
  if (updatePasswordTime) {
    const currentTime = moment(new Date())
    const time = moment(this.updatePasswordTime).add(90, 'days')
    const date = moment.max(currentTime, time).format('YYYY-MM-DD')
    isOverTime = moment.max(currentTime, time) === currentTime
  }
  return isOverTime
}

const user = {
  state: {
    aiisToken: getStore({ name: 'aiisToken' }) || '',
    tenantId: getStore({ name: 'tenantId' }) || '',
    userInfo: getStore({ name: 'userInfo' }) || [],
    userAllInfo: getStore({ name: 'userAllInfo' }) || {},
    permission: getStore({ name: 'permission' }) || {},
    roles: [],
    menuId: {},
    menu: getStore({ name: 'menu' }) || [],
    dicts: getStore({ name: 'dicts' }) || [],
    dictsStaticData: getStore({ name: 'dictsStaticData' }) || {},
    menuAll: getStore({ name: 'menuAll' }) || [],
    token: getStore({ name: 'token' }) || '',
    refreshToken: getStore({ name: 'refreshToken' }) || '',
    // 验证登录进来后密码是否是初始密码
    isInitPasswordFlag: getStore({ name: 'isInitPasswordFlag' }) || false,
    tempUserInfo: {} || {},
    // 判断密码是否修改好
    isUpdatedPasswordFlag: false,
    // 所有的自定义表单templateForm
    templateForm: getStore({ name: 'templateForm' }) || [],
    // 课程字典列表
    courseList: getStore({ name: 'courseList' }) || [],
    // 流程通知参数
    noticeProcessParams: getStore({ name: 'noticeProcessParams' }) || [],
  },
  actions: {
    // 根据用户名登录
    LoginByUsername({ state, commit, dispatch }, userInfo) {
      console.log(userInfo, 'aaaaaaaaaa')
      return new Promise((resolve, reject) => {
        loginByUsername(userInfo.tenantId, userInfo.username, md5(userInfo.password), userInfo.type, userInfo.key, userInfo.code, userInfo.phone, userInfo.otpCode, userInfo.isPhoneLogin).then(res => {
          const { data } = res
          commit('SET_TOKEN', '')
          if (data.error_description) {
            Vue.$toast({
              component: ToastificationContent,
              props: {
                title: 'ERROR',
                icon: 'BellIcon',
                text: data.error_description,
                variant: 'danger',
              },
            })
            reject()
          } else if (userInfo.password === 'mcc123456') {
            data.updateType = 'firstUpdate'
            commit('saveUserInfo', data)
            commit('getIsInitPassWordStatus', true)
            reject()
            // commit('getIsUpdatedPasswordFlag', true)
          } else if (userInfo.updatePasswordTime && isOverTime(userInfo.updatePasswordTime)) {
            data.updateType = 'overtimeUpdate'
            commit('saveUserInfo', data)
            commit('getIsInitPassWordStatus', true)
            reject()
          } else {
            commit('SET_TOKEN', data.access_token)
            commit('SET_REFRESH_TOKEN', data.refresh_token)
            commit('SET_TENANT_ID', data.tenant_id)
            commit('SET_USER_INFO', data)
            commit('DEL_ALL_TAG')
            commit('CLEAR_LOCK')
            dispatch('GetUserInfo')
            dispatch('GetDicts')
            dispatch('GetTemplateForm')
            dispatch('getDictsList')
            resolve()
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    LoginByToken({ state, commit, dispatch }, userInfo) {
      console.log(userInfo, 'hhhh')
      return new Promise((resolve, reject) => {
        loginByToken(userInfo).then(res => {
          const { data } = res
          commit('SET_TOKEN', '')
          if (data.error_description) {
            Vue.$toast({
              component: ToastificationContent,
              props: {
                title: 'ERROR',
                icon: 'BellIcon',
                text: data.error_description,
                variant: 'danger',
              },
            })
            reject()
          } else if (userInfo.password === 'mcc123456') {
            data.updateType = 'firstUpdate'
            commit('saveUserInfo', data)
            commit('getIsInitPassWordStatus', true)
            reject()
            // commit('getIsUpdatedPasswordFlag', true)
          } else if (userInfo.updatePasswordTime && isOverTime(userInfo.updatePasswordTime)) {
            data.updateType = 'overtimeUpdate'
            commit('saveUserInfo', data)
            commit('getIsInitPassWordStatus', true)
            reject()
          } else {
            commit('SET_TOKEN', data.access_token)
            commit('SET_REFRESH_TOKEN', data.refresh_token)
            commit('SET_TENANT_ID', data.tenant_id)
            commit('SET_USER_INFO', data)
            commit('DEL_ALL_TAG')
            commit('CLEAR_LOCK')
            dispatch('GetUserInfo')
            dispatch('GetDicts')
            dispatch('GetTemplateForm')
            dispatch('getDictsList')
            resolve()
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetTemplateForm({ commit }) {
      return new Promise((resolve, reject) => {
        templateFormAPI.formPage(1, -1).then(res => {
          const { data } = res.data
          commit('SET_TEMPLATEFORM', data.records);
          resolve(data.records);
        }).catch(err => {
          reject(err);
        })
      })
    },
    GetDicts({ commit }) {
      return new Promise((resolve, reject) => {
        getDictlist(1, -1).then(res1 => {
          const dictList = res1.data.data;
          getDictBizlist(1, -1).then(res2 => {
            const dictBizList = res2.data.data;
            const obj = {
              dict: dictList,
              dictBiz: dictBizList,
            }
            commit('SET_DICTS', obj);
            resolve(dictList);
          }).catch(err => {
            reject(err);
          })
        }).catch(err => {
          reject(err);
        })
      })
    },
    GetUserInfo({ commit }) {
      return new Promise((resolve, reject) => {
        getUserAllInfo().then(res => {
          const { data } = res.data
          commit('SET_ROLES', data.roles)
          commit('SET_DATE_FORMAT', data.dateFormat)
          delete data.password
          commit('SET_USER_ALL_INFO', data)
          resolve(data);
        }).catch(err => {
          reject(err);
        })
      })
    },
    // 根据手机号登录
    LoginByPhone({ commit }, userInfo) {
      return new Promise(resolve => {
        loginByUsername(userInfo.phone, userInfo.code).then(res => {
          const { data } = res.data
          commit('SET_TOKEN', data)
          commit('DEL_ALL_TAG')
          commit('CLEAR_LOCK')
          resolve()
        })
      })
    },
    // 根据第三方信息登录
    LoginBySocial({ commit }, userInfo) {
      return new Promise(resolve => {
        loginBySocial(userInfo.tenantId, userInfo.source, userInfo.code, userInfo.state).then(res => {
          const { data } = res
          if (data.error_description) {
            // Message({
            //   message: data.error_description,
            //   type: 'error',
            // });
          } else {
            commit('SET_TOKEN', data.access_token)
            commit('SET_REFRESH_TOKEN', data.refresh_token)
            commit('SET_USER_INFO', data)
            commit('DEL_ALL_TAG')
            commit('CLEAR_LOCK')
          }
          resolve()
        })
      })
    },
    // 刷新token
    refreshToken({ state, commit }) {
      window.console.log('handle refresh token')
      return new Promise((resolve, reject) => {
        refreshToken(state.refreshToken, state.tenantId).then(res => {
          const { data } = res
          commit('SET_TOKEN', data.access_token)
          commit('SET_REFRESH_TOKEN', data.refresh_token)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 登出
    LogOut({ commit }) {
      return new Promise((resolve, reject) => {
        logout().then(() => {
          commit('SET_TOKEN', '')
          commit('SET_MENU', [])
          commit('SET_MENU_ALL_NULL', [])
          commit('SET_ROLES', [])
          commit('SET_TAG_LIST', [])
          commit('DEL_ALL_TAG')
          commit('CLEAR_LOCK')
          commit('getIsInitPassWordStatus', false)
          commit('SET_DICTS_STATIC_DATA', {});
          removeToken()
          removeRefreshToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 注销session
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        commit('SET_MENU_ALL_NULL', [])
        commit('SET_MENU', [])
        commit('SET_ROLES', [])
        commit('SET_TAG_LIST', [])
        commit('DEL_ALL_TAG')
        commit('CLEAR_LOCK')
        removeToken()
        removeRefreshToken()
        resolve()
      })
    },
    // 获取顶部菜单
    // GetTopMenu() {
    //   return new Promise(resolve => {
    //     getTopMenu().then(res => {
    //       const data = res.data.data || []
    //       resolve(data)
    //     })
    //   })
    // },
    // 获取系统菜单
    GetMenu({ commit, dispatch }, topMenuId) {
      return new Promise(resolve => {
        getRoutes(topMenuId).then(res => {
          const { data } = res.data
          const menu = deepClone(data)
          menu.forEach(ele => {
            addPath(ele, true)
          })
          commit('SET_MENU_ALL', menu)
          commit('SET_MENU', menu)
          dispatch('GetButtons')
          resolve(menu)
        })
      })
    },
    // 获取系统按钮
    GetButtons({ commit }) {
      return new Promise(resolve => {
        getButtons().then(res => {
          const { data } = res.data
          commit('SET_PERMISSION', data)
          resolve()
        })
      })
    },
    // 获取课程字典
    getDictsList({ state, commit }) {
      return new Promise((resolve, reject) => {
        getDictBizlist(1, -1, { parentId: '1472776615213780993' }).then(res => {
          const temp = res.data.data;
          commit('SET_COURSE_LIST', temp);
        });
      });
    },
  },
  mutations: {
    SET_AIIS_TOKEN: (state, aiisToken) => {
      state.aiisToken = aiisToken
      setStore({ name: 'aiisToken', content: state.aiisToken })
    },
    SET_TOKEN: (state, token) => {
      setToken(token)
      state.token = token
      setStore({ name: 'token', content: state.token })
    },
    SET_DICTS: (state, dicts) => {
      state.dicts = dicts
      setStore({ name: 'dicts', content: state.dicts })
    },
    SET_DICTS_STATIC_DATA: (state, dictsStaticData) => {
      state.dictsStaticData = dictsStaticData
      setStore({ name: 'dictsStaticData', content: state.dictsStaticData })
    },
    SET_TEMPLATEFORM: (state, templateForm) => {
      state.templateForm = templateForm
      setStore({ name: 'templateForm', content: state.templateForm })
    },
    SET_MENU_ID(state, menuId) {
      state.menuId = menuId
    },
    SET_USER_ALL_INFO: (state, userAllInfo) => {
      state.userAllInfo = userAllInfo
      setStore({ name: 'userAllInfo', content: state.userAllInfo })
    },
    SET_MENU_ALL: (state, menuAll) => {
      const menu = state.menuAll
      menuAll.forEach(ele => {
        if (!menu.find(item => item.label === ele.label && item.path === ele.path)) {
          menu.push(ele)
        }
      })
      state.menuAll = menu
      setStore({ name: 'menuAll', content: state.menuAll })
    },
    SET_MENU_ALL_NULL: state => {
      state.menuAll = []
      setStore({ name: 'menuAll', content: state.menuAll })
    },
    SET_MENU: (state, menu) => {
      state.menu = menu
      setStore({ name: 'menu', content: state.menu })
    },
    SET_REFRESH_TOKEN: (state, token) => {
      setRefreshToken(token)
      state.refreshToken = token
      setStore({ name: 'refreshToken', content: state.refreshToken })
    },
    SET_TENANT_ID: (state, tenantId) => {
      state.tenantId = tenantId
      setStore({ name: 'tenantId', content: state.tenantId })
    },
    SET_USER_INFO: (state, _userInfo) => {
      if (validatenull(_userInfo.avatar)) {
        // eslint-disable-next-line no-param-reassign
        // _userInfo.avatar = '/img/bg/img-logo.png'
      }
      state.userInfo = _userInfo
      setStore({ name: 'userInfo', content: state.userInfo })
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_PERMISSION: (state, permission) => {
      const result = []

      function getCode(list) {
        list.forEach(ele => {
          if (typeof (ele) === 'object') {
            const chiildren = ele.children
            const { code } = ele
            if (chiildren) {
              getCode(chiildren)
            } else {
              result.push(code)
            }
          }
        })
      }

      getCode(permission)
      state.permission = {}
      result.forEach(ele => {
        state.permission[ele] = true
      })
      setStore({ name: 'permission', content: state.permission })
    },
    SET_PROCESS_PARAMS: (state, params) => {
      state.noticeProcessParams = params
    },
    SET_COURSE_LIST: (state, courseList) => {
      state.courseList = courseList
    },
    getIsInitPassWordStatus(state, value) {
      state.isInitPasswordFlag = value
      setStore({ name: 'isInitPasswordFlag', content: state.isInitPasswordFlag })
    },
    saveUserInfo(state, value) {
      state.tempUserInfo = value
    },
    // 判断密码是否修改好flag
    getIsUpdatedPasswordFlag(state, value) {
      state.isUpdatedPasswordFlag = value
    },
  },

}
export default user
